import { schema } from "normalizr";
import { userSchema } from "../users/usersNormalizer";
import { messageSchema } from "../messages/messagesNormalizer";

export const chatSchema = new schema.Entity("chats", {
  user: userSchema,
  messages: [messageSchema]
});
